import type { TypeOnDemandWithoutUnresolvableLinksResponse } from '@/contentful/types';

export const paginateOnDemandList = async (query: FilterQuery) => {
  try {
    const params = new URLSearchParams(
      query as unknown as Record<string, string>
    );
    const response = await fetch(`/api/on-demand?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
      // body: JSON.stringify({ query }),
    });
    if (!response.ok) {
      throw new Error('Error retrieving onDemandList');
    }
    const data = (await response.json()) as {
      onDemandList: TypeOnDemandWithoutUnresolvableLinksResponse[];
      total: number;
    };
    return data;
  } catch (error) {
    console.error('Error retrieving onDemandList:', error);
    return {
      onDemandList: [],
      total: 0
    };
  }
};

// type SearchResponse = {
//   docs: OnDemandSummary[];
//   nextPage: number;
// };

// export const searchOnDemandItems = async (
//   query: QueryStringParameters
// ): Promise<SearchResponse> => {
//   try {
//     const response = await fetch("/api/on-demand", {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
//       // body: JSON.stringify({ search: query }),
//     });
//     if (!response.ok) {
//       throw new Error("Error retrieving On Demand results");
//     }
//     const data = (await response.json()) as SearchResponse;
//     return data;
//   } catch (error) {
//     console.error("Error retrieving On Demand results:", error);
//     return {
//       docs: [],
//       nextPage: 0,
//     };
//   }
// };

// export const getOnDemandDetails = async (
//   id: string
// ): Promise<OnDemand | null> => {
//   try {
//     const response = await fetch(`/api/on-demand/${id}`, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//       },
//     });
//     if (!response.ok) {
//       throw new Error("Error retrieving onDemand");
//     }
//     const data = (await response.json()) as { onDemand: OnDemand };
//     return data.onDemand;
//   } catch (error) {
//     console.error("Error retrieving onDemand:", error);
//     return null;
//   }
// };
